export default "__VITE_ASSET__DG4VRCvW__"